<template>
  <div class="box-card">
    <el-row :gutter="12">
      <el-col :span="19">
        <span class="title">{{ $t("message.title.importBOM") }}</span>
      </el-col>
      <el-col :span="4">
        <el-steps :active="active" finish-status="success">
          <el-step></el-step>
          <el-step></el-step>
          <el-step></el-step>
          <br /> <br />
        </el-steps>
      </el-col>
      <el-dialog title="导入操作手册" :visible.sync="dialogVisible" width="60%">
        <span class="importManual">
          <p2>第一步：选择‘父级’数据类型并导出模板</p2><br />
          <img src="@/assets/import/BOMimport1.png" width="100%" alt="" />
          <img src="@/assets/import/BOMimport1.1.png" width="100%" alt="" />
          <p2>第三步：准备模板数据</p2>
          <img src="@/assets/import/BOMimport2.png" width="100%" alt="" />
          <p2>第四步：回到系统，进行下一步操作</p2>
          <img src="@/assets/import/BOMimport3.png" width="100%" alt="" />
          <p2>第五步：选择变更单，上传文件,系统中父子BOM结构导入成功</p2>
        </span>
      </el-dialog>
      <el-col style="margin-top: 5px">
        <el-divider></el-divider>
      </el-col>
      <el-col>
        <el-carousel ref="carousel" class="content" arrow="never" indicator-position="none" height="400px"
          :autoplay="autop">
          <el-carousel-item class="item">
            <el-row style="margin-top: 70px; height: 240px">
              <el-col :span="15" :offset="5" style="font-weight: 600">
                <span>{{ $t("message.title.fileModel") + " : " }}</span>
                <el-cascader ref="subSelect" size="small" class="input-model" v-model="value" :options="options"
                  @change="selectType" clearable="">
                </el-cascader>
              </el-col>
              <el-col :span="15" :offset="5" style="margin-top:25px">
                <span>
                  <el-tag style="margin-left: 8.8%;" type="text" @click="dialogVisible = true" class="tip-tag">
                    <i class="el-icon-info" style="font-size:14px"></i>
                    <span style="">{{ $t("message.tips.tip") + " : " }}</span>{{ $t("message.tips.exportBom") }}
                  </el-tag>
                </span>
              </el-col>
            </el-row>
            <vxe-grid v-show="tableShow" ref="xTable" v-bind="addTableList">
            </vxe-grid>
            <el-row>
              <el-col :span="6" :offset="16">
                <div style="width: 200px; overflow: hidden">
                  <el-button type="primary" size="small" @click="next" :disabled="!isSelect">{{
                    $t("message.button.next") }}</el-button>
                  <el-button type="primary" size="small" style="margin-left: 5px" @click="exportDataEvent"
                    :disabled="!isSelect">{{ $t("message.button.exportModel") }}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
          <el-carousel-item style="height:560px" v-if="systemName.indexOf('奥斯汀') == -1">
            <!-- <el-carousel-item style="height:560px"> -->
            <div class="model lastPage">
              <el-row>
                <el-col :span="21" :offset="1">
                  <add-change @getChangeInfo="addList" @listDbClick="addList" :baseId="baseId"></add-change>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" :offset="16">
                  <el-button size="small" @click="next" :disabled="!changeId">{{
                    $t("message.button.next")
                  }}</el-button>
                  <el-button size="small" @click="cancel">{{
                    $t("message.button.cancel")
                  }}</el-button>
                </el-col>
              </el-row>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="model">
              <el-row>
                <el-col :span="16" :offset="5">
                  <el-upload class="upload-demo" action="" :show-file-list="false" :before-upload="importFile">
                    <span style="display: inline-blcok">{{ $t("message.title.fileImport") }}:</span>
                    <el-button size="small" type="primary" style="margin-left: 5px">{{ $t("message.button.toImport")
                    }}</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                  </el-upload>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="model">
                <el-upload
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  :before-upload="importFile"
                >
                  <span style="display: inline-blcok">文件上传:</span>
                  <el-button
                    size="small"
                    type="primary"
                    style="margin-left: 5px"
                    >点击上传</el-button
                  > -->
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- </el-upload>
              </div> -->
            <el-row>
              <el-col :span="6" :offset="16">
                <el-button size="small" @click="cancel">{{
                  $t("message.button.cancel")
                }}</el-button>
              </el-col>
            </el-row>
          </el-carousel-item>

          <el-carousel-item style="height:560px">
            <div class="model">
              <ul style="
                    position: relative;
                    overflow: hidden;
                    overflow: hidden;
                    list-style: none;
                    width: 100%;
                    margin-top: 50px;
                  ">
                <li v-for="item in fileInfo" class="file-info" :key="item.id">
                  <div class="table-list">
                    <span class="list-key-1">{{ item.name }}</span>
                    <span style="display: inline-block; margin: 0 6px">:</span>
                    <span class="list-val" :title="item.val">{{
                      item.val
                    }}</span>
                  </div>
                </li>
                <div class="file-info">
                  <div class="table-list">
                    <span class="list-key-1">{{ "变更单编号(点击跳转)" }}</span>
                    <span style="display: inline-block; margin: 0 6px">:</span>
                    <span>
                      <el-link type="primary" @click="jumpToChange">{{ changeItem.title }}</el-link>
                    </span>
                  </div>
                </div>
              </ul>
            </div>
            <el-row>
              <el-col :span="6" :offset="16">
                <el-button size="small" @click="done">{{
                  $t("message.title.finish")
                }}</el-button>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import addChange from "@/components/relSearchAdd.vue";
import axios from "axios";
export default {
  data() {
    return {
      dialogVisible: false,
      options: [],
      tableShow: false,
      value: "",
      subClass: "",
      active: 0,
      autop: false,
      isSelect: false,
      addTableList: {
        columns: [],
      },
      fileInfo: [],
      baseId: 104,
      changeId: "",
      systemName: "",
      changeItem: {
        id: '',
        classId: '',
        subclassId: '',
        title: ''
      },
    };
  },
  components: { addChange },
  methods: {
    jumpToChange() {
      this.getLink(this.changeItem);
    },
    getTable(e) {
      console.log(e);
      if (e.length) {
        let obj = {
          baseId: 1,
          classId: 1,
          subClassId: e[2],
        };
        let url = `/pmdm/importTemplate/getImportTemplate${this.params(obj)}`;
        axios.post(url).then((res) => {
          let n = Object.values(res.data.object.fieldList);
          // console.log(n);
          // // n[0].id = n[0].id - 1;
          // console.log(n);
          this.addTableList.columns = n.map((i) => {
            return { field: i.id, title: i.name };
          });
          // console.log(this.addTableList.columns);
        });
      }
    },
    selectType(e) {
      this.isSelect = Boolean(e.length);
      this.getTable(e);
    },
    addList(arr) {
      //添加
      // console.log(row);
      let row = arr[0];
      console.log(row);
      this.changeId = row.itemId;
      const { itemId, itemClass, itemSubClass } = row;
      this.changeItem = {
        id: itemId,
        classId: itemClass,
        subclassId: itemSubClass,
        title: row[0]
      };
    },
    importFile(file) {
      // console.log(file);
      // this.filePro = file;
      let obj_name = {};
      obj_name.name = this.$t("message.title.fileName");
      obj_name.val = file["name"];
      let obj_time = {};
      obj_time.name = this.$t("message.title.importDate");
      obj_time.val = this.formatDate(file["lastModified"]);

      let arr = [obj_name, obj_time];

      let fd = new FormData();
      console.log(fd);
      fd.append("file", file);
      fd.append("id", 1);
      fd.append("classId", 1);
      fd.append("subClassId", this.value[2]);

      if (this.systemName.indexOf("奥斯汀") == -1) {
        fd.append("changeId", this.changeId);
      } else {
        fd.append("changeId", 0);
        fd.append("changeClassId", 0);
        fd.append("changeSubClassId", 0);
      }

      // let url = this.urlList.filter(i => {return i.baseId == this.value[0]})[0].url
      // console.log(url);
      axios.post("/pmdm/import/importBoms", fd).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          let m = res.data.object;
          let n = Object.keys(m).map((i, e) => {
            return {
              name: i,
              val: Object.values(m)[e],
            };
          });
          this.fileInfo = arr.concat(n);
          // console.log(this.fileInfo);
          this.next();
        }
      });
    },
    next() {
      console.log(this.value);
      this.$refs.carousel.next();
      this.active++;
    },
    cancel() {
      this.$refs.carousel.prev();
      this.active--;
    },
    downLoad() {
      //  console.log(this.value.length);
    },
    exportDataEvent() {
      // console.log(this.$refs.subSelect);
      const n = this.$refs.subSelect.presentText;
      const arr = n.split("/").map((i) => i.trim());
      // console.log(arr);
      this.$refs.xTable.exportData({
        filename: "BOM_" + arr[arr.length - 1],
        sheetName: "Sheet1",
        type: "xlsx",
      });
    },
    async getInfo() {
      const { data: res } = await this.$http.get(
        "/pmdm/admin/getClassListNewStyle"
      );
      this.options = res.object.clsList.filter((i) => i.value == 101);
      // let arr = [];
      // for (let i = 0; i < this.options.length; i++) {
      //   const e = this.options[i];
      //   console.log(e.children);
      //   for (let j = 0; j < e.children.length; j++) {
      //     const l = e.children[j];
      //     arr = arr.concat(l.children);
      //   }
      // }
      // this.modelNames = arr;
    },
    done() {
      this.$emit("deletePage", "/importBoms");
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
  },
  created() {
    // this.getTable();
    this.getInfo();
    this.systemName = window.sessionStorage.getItem("systemName");
  },
};
</script>
<style>
.box-card .el-carousel__container {
  height: 480px !important;
}
</style>
<style scoped>
.box-card {
  /* width: 100%; */
  /* height: 660px; */
  padding: 20px;
  background: #fff;
}

.content {
  width: 96%;
  height: 600px;

}

.item {
  height: 600px;
}

.file-info {
  width: 100%;
  margin-left: 120px;
  text-align: left;
}

.model {
  margin-top: 25px;
  margin-left: 120px;
  /* text-align: center; */
  height: 240px;
  padding-top: 45px;
}

.input-model {
  margin-left: 5px;
  width: 36%;
}

.next-click {
  margin-left: 540px;
  text-align: center;
  overflow: hidden;
  width: 160px;
  /* float: right;
    margin-top: 140px;
    margin-left: 120px; */
}

.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}

.importManual p2 {
  font-size: 15px;
  font-weight: bold;
  margin: 20px;
  height: 36px;
  line-height: 36px;
}

.tip-tag {
  cursor: pointer;
}
</style>